import { Box, Grid, Typography } from '@mui/material';

import {
  getPriorityColor,
  type PriorityTypes
} from '@/components/PriorityChip';
import { PRIORITY_COLORS } from '@/constants/chartcolors.constants';
import type { TicketsAckTimesDTO } from '@/pages/Dashboard/Dashboard.types';

import useStyles from './AvgAckTimeWidget.styles';
import convertTime from './AvgAckTimeWidget.utils';

const AvgAckTimeWidget = ({
  allPrioritiesAckTimes,
  showAllPriorities = true
}: {
  allPrioritiesAckTimes?: TicketsAckTimesDTO[];
  showAllPriorities?: boolean;
}) => {
  const priorityNames = Object.keys(PRIORITY_COLORS);
  const { classes } = useStyles();

  const allPrioritiesData = priorityNames
    .map((_priority, index) => {
      const priorityNumber = index + 1;
      const priorityData = allPrioritiesAckTimes?.find(
        (item: TicketsAckTimesDTO) => item?.priority === priorityNumber
      );

      if (!priorityData) {
        return showAllPriorities
          ? { priority: priorityNumber, time_to_status_minutes: 0 }
          : undefined;
      }
      return priorityData;
    })
    .filter(Boolean);

  return (
    <Grid
      className={classes.prioritiesContainer}
      sx={{
        height: '100%',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
      container
      spacing={2}
    >
      {allPrioritiesData.map((item) => (
        <Grid
          size={{ xs: 2 }}
          key={item?.priority}
          style={{ textAlign: 'center', paddingTop: '0', alignItems: 'center' }}
        >
          <Box
            style={{
              backgroundColor: `var(--mui-palette-${getPriorityColor(
                item?.priority as PriorityTypes
              )}-main)`
            }}
            className={classes.priority}
          >
            {`P${item?.priority}`}
          </Box>
          <Typography className={classes.timeDisplay} variant="h6">
            {convertTime(item?.time_to_status_minutes as number).time}
          </Typography>
          <Typography className={classes.unitsDisplay} variant="body1">
            {convertTime(item?.time_to_status_minutes as number).unit}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default AvgAckTimeWidget;
